const isValidObjectID = (str) => {
	try {
		const isValid = str.match(/^[0-9a-fA-F]{24}$/);
		return isValid;
	} catch (ermahgerd) {
		return false;
	}
};

export default isValidObjectID;
